import { Fragment, useEffect, useState } from "react";
import Hero from "@/components/Hero";
import PriceEdits from "@/components/PriceEdits";
import OfferEdits from "@/components/OfferEdits";
import ProductShowcase from "@/components/ProductShowcase";
import EditorialMarquee from "@/components/EditorialMarquee";
import CategoryGrid from "@/components/CategoryGrid";
import Manifesto from "@/components/Manifesto";
import BrandIndex from "@/components/BrandIndex";
import CmsBanner from "@/components/CmsBanner";
import { fetchHomeSections } from "@/lib/cms";
import { useSeo } from "@/lib/seo";

const DEFAULT_SECTIONS = [
  { type: "hero" },
  { type: "offer_edit" },
  { type: "price_edit" },
  { type: "editorial_marquee" },
  { type: "category_grid" },
  { type: "manifesto" },
  { type: "brand_index" },
];

const RENDERERS = {
  hero: (s) => <Hero data={s.content} />,
  offer_edit: (s) => <OfferEdits data={s.content} />,
  product_showcase: (s) => <ProductShowcase data={s.content} />,
  price_edit: (s) => <PriceEdits data={s.content} />,
  editorial_marquee: (s) => <EditorialMarquee data={s.content} />,
  category_grid: (s) => <CategoryGrid data={s.content} />,
  manifesto: (s) => <Manifesto data={s.content} />,
  brand_index: (s) => <BrandIndex data={s.content} />,
  image_banner: (s) => <CmsBanner content={s.content} />,
  video_banner: (s) => <CmsBanner content={s.content} />,
};

export default function HomePage() {
  const [sections, setSections] = useState(null); // { list, fromCms }

  useSeo({
    title: "Soonyoung — Buy Cosmetics & Beauty Products Online in India | Best Prices",
    description: "Cosmetics online shopping in India at Soonyoung — buy original beauty products & makeup online from Himalaya, Lakmé, L'Oréal Paris, MAC, Fenty Beauty, Huda Beauty, The Ordinary, Biotique & more. Affordable beauty products at best price with free delivery over ₹999 in Mumbai, Delhi, Chennai, Bengaluru, Hyderabad, Kolkata, Pune & all India.",
    path: "/",
  });

  useEffect(() => {
    fetchHomeSections().then((s) =>
      setSections({ list: s && s.length ? s : DEFAULT_SECTIONS, fromCms: !!(s && s.length) })
    );
  }, []);

  if (!sections) return <div className="min-h-screen" data-testid="home-loading" />;

  const { list, fromCms } = sections;

  return (
    <div data-testid="home-cms-root">
      {(() => {
        const hasOfferEdit = list.some((s) => s.type === "offer_edit");
        return list.map((s, i) => {
          const render = RENDERERS[s.type];
          return (
            <Fragment key={s.id || i}>
              {render ? render(s) : null}
              {/* Auto-place after hero only when the CMS isn't controlling sections */}
              {s.type === "hero" && !fromCms && !hasOfferEdit && <OfferEdits />}
            </Fragment>
          );
        });
      })()}
    </div>
  );
}
